import { ActionIcon, Group, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

export function InlineNotice({ tone, message, onClose }: Readonly<{
  tone: 'error' | 'success';
  message: string;
  onClose?: () => void;
}>) {
  const color = tone === 'success' ? 'var(--status-success)' : 'var(--status-danger)';
  return (
    <Group
      role={tone === 'error' ? 'alert' : 'status'}
      mt="sm" gap={12} wrap="nowrap" justify="space-between" align="center"
      style={{
        padding: '10px 14px',
        borderRadius: 8,
        border: `1px solid color-mix(in srgb, ${color}, transparent 65%)`,
        background: `color-mix(in srgb, ${color}, transparent 88%)`,
      }}
    >
      <Text c={color} size="sm">{message}</Text>
      {onClose && (
        <ActionIcon variant="subtle" size="sm" aria-label="Dismiss" onClick={onClose}
          style={{ '--ai-color': color, '--ai-hover': `color-mix(in srgb, ${color}, transparent 88%)` }}>
          <IconX size={16} />
        </ActionIcon>
      )}
    </Group>
  );
}
